import { useSelector } from "react-redux";

import { contactFormSelector } from "../../selectors/selectors";

const formatErrors = errors =>
  errors?.reduce((acc, error) => {
    acc[error.type] = error.message;
    return acc;
  }, {});

export const useContactFormData = () => {
  const contactForm = useSelector(contactFormSelector);

  return {
    ...contactForm,
    errors: formatErrors(contactForm.errors)
  };
};
